<script lang="ts">
	import { stationStore } from "../../store";
  const { getSelectedStation, useCase, showPlayer} = stationStore;
  let radius = 52;
  let circumference = radius * 2 * Math.PI;
</script>

<div class="col-lg-6">
    <div class="row radio-live-bar-top">
      <div class="col-4">
        <span>
        <div class="circle-item pr-xl-4">
          <div class="circle-with-progress container-1-1">
            <div class="circle-with-progress-bg inactive-bg" style="background-image: url({$getSelectedStation.overlay_background});"></div>
            {#if $getSelectedStation.overlay_front}
            <div class="circle-with-progress-img" style="background-image: url({$getSelectedStation.overlay_front});"></div>
            {/if}
            <svg
              class="rotating-circle-progress"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              viewBox="0 0 110 110"
            >
              <defs>
                <pattern
                  id="img-channel-{$getSelectedStation.class}"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <image
                    x="0"
                    y="0"
                    width="1"
                    height="1"
                    preserveAspectRatio="xMidYMid slice"
                    xlink:href="{$getSelectedStation.overlay_icon}"></image>
                </pattern>
              </defs>
              <circle
                class="circle-progress-bg-stroke"
                stroke-width="4"
                fill="transparent"
                r="52"
                cx="55"
                cy="55"></circle>
              <circle
                class="progress-ring__circle"
                stroke="var(--{$getSelectedStation.color})"
                stroke-width="4"
                fill="transparent"
                r="{radius}"
                cx="55"
                cy="55"
                style="stroke-dasharray: 326.726, 326.726; stroke-dashoffset: {$getSelectedStation
                  .overlay_procent}"></circle>
            </svg>
          </div>
        </div>
      </span>
      </div>
      <div class="col-8 font-size-sm">
        {#if $getSelectedStation.speaker_name} 
          <div class="muted">V studiu: </div>
          <div class="h3 mb-0">{$getSelectedStation.speaker_name}</div>
        {/if}
        {#if $getSelectedStation.music_editor_name}
          <div><span class="muted">Izbor glasbe: </span> {$getSelectedStation.music_editor_name}</div>
        {/if}
      <!--  <button type="button" class="mt-3 px-3 btn btn-primary" on:click="{() => $showPlayer = !$showPlayer}"> -->
        <span>
        <button type="button" class="mt-3 px-3 btn btn-primary" onclick="window._globaLiveRadioPlayerCommands.dEvent('E_TOOGLE_PLAY_PAUSE')">
          <span class="icon-play-live mr-2 d-inline-block" style="transform: scale(1.3);"></span>
          Poslušaj
          <span class="muted">
            <span class="separatorRadio" aria-hidden="true"></span>
            <span class="icon-user mr-1 small"></span>{$getSelectedStation.listeners}
          </span>
        </button>
      </span>
        <div class="mt-3 muted shownameshort"><strong>{$getSelectedStation.overlay_bottom_text} </strong></div>
      </div>
    </div>
  </div>


<style lang="scss">
  @import "../../style/main";
</style>